import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { useStorefrontTenant } from "context/StorefrontTenantContext";
import { readStorefrontTenant } from "lib/storefront";
import { resolveStorefrontAssetUrl } from "lib/storefrontTheme";
import shortLogo from "assets/images/logos/ShortLogo.png";

const VARIANTS = {
  header: { height: 44, maxWidth: 148 },
  signIn: { height: 52, maxWidth: 180 },
  footer: { height: 40, maxWidth: 156 },
};

export default function VbsLogo({ variant, alt, logoUrl, centered }) {
  const { tenant } = useStorefrontTenant();
  const cached = readStorefrontTenant();
  const preset = VARIANTS[variant] || VARIANTS.header;
  const resolvedLogoUrl = logoUrl || tenant?.brandLogoUrl || cached?.brandLogoUrl;
  const brandLogo = resolveStorefrontAssetUrl(resolvedLogoUrl) || shortLogo;
  const brandName = tenant?.name || cached?.name || "Valve Body Specialties";

  return (
    <Box
      component="img"
      src={brandLogo}
      alt={alt || brandName}
      sx={{
        height: preset.height,
        width: "auto",
        maxWidth: preset.maxWidth,
        display: "block",
        mx: centered ? "auto" : undefined,
        objectFit: "contain",
        objectPosition: centered ? "center center" : "left center",
      }}
    />
  );
}

VbsLogo.propTypes = {
  variant: PropTypes.oneOf(["header", "signIn", "footer"]),
  alt: PropTypes.string,
  logoUrl: PropTypes.string,
  centered: PropTypes.bool,
};

VbsLogo.defaultProps = {
  variant: "header",
  alt: "",
  logoUrl: undefined,
  centered: false,
};
